import PropTypes from 'prop-types';
import React from 'react';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { ProfileViewRow } from '../../../common/ProfileView/ProfileViewRow';
import { useFindEligibilityForInsurance } from '../../hooks/useFindEligibilityForInsurance';
import { isEligibilityPending } from '../../utils/isEligibilityPending';
import { ExpiryMessage } from './ExpiryMessage';
import { MatchView } from './MatchView';
import { MatchWarning } from './MatchWarning';
import { SomethingWentWrong } from './SomethingWentWrong';
import { MissingNpiErrorMessage } from './MissingNpiErrorMessage';
import { CurrentInsuranceCoverageMessage } from './CurrentInsuranceCoverageMessage';
var MatchMessage = function MatchMessage(_ref) {
  var eligibility = _ref.eligibility,
    hasDobError = _ref.hasDobError,
    hasNameError = _ref.hasNameError,
    isPending = _ref.isPending,
    isExpired = _ref.isExpired;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProfileViewRow, null, /*#__PURE__*/React.createElement(MatchView, {
    label: "Member ID",
    pending: isPending,
    match: eligibility.member_id_match,
    successMessage: "Match found for member ID",
    failureMessage: "No match found for member ID"
  }), /*#__PURE__*/React.createElement(MatchView, {
    label: "Managed Care or PIHP Enrollment",
    pending: isPending,
    match: eligibility.managed_care_member,
    successMessage: "Active in managed care or PIHP",
    failureMessage: "Not active in managed care or PIHP"
  }), /*#__PURE__*/React.createElement(MatchView, {
    label: "Medicaid Plan",
    pending: isPending,
    match: eligibility.payer_name_match,
    successMessage: "Match found for plan",
    failureMessage: "No match found for plan"
  }), hasNameError && /*#__PURE__*/React.createElement(MatchWarning, {
    label: "Client Name",
    message: "No match found for client name",
    tooltipMessage: "Please verify that the client's first and last name are correctly entered on the face sheet."
  }), hasDobError && /*#__PURE__*/React.createElement(MatchWarning, {
    label: "Client Date of Birth",
    message: "No match found for client date of birth",
    tooltipMessage: "Please verify that the client's date of birth is correctly entered on the face sheet."
  })), isExpired && /*#__PURE__*/React.createElement(ExpiryMessage, {
    expiredDateString: eligibility.verified_at
  }));
};
export var NcTracksVerification = function NcTracksVerification(_ref2) {
  var insurance = _ref2.insurance;
  var isPaymentsUser = useFeatureFlag('isPaymentsUser');
  var ncTracksFF = useFeatureFlag('pays-1554-nctracks');
  var isNcTracksEnabled = isPaymentsUser && ncTracksFF;
  var pays5525ShowCurrentInsuranceCoverage = useFeatureFlag('pays-5525-show-current-insurance-coverage');
  var eligibility = useFindEligibilityForInsurance(insurance, isNcTracksEnabled);
  if (!isNcTracksEnabled) return null;
  var isPending = isEligibilityPending(eligibility);
  var hasNameError = eligibility === null || eligibility === void 0 ? void 0 : eligibility.x12_rejection_reasons.some(function (reason) {
    return reason.code === '73';
  });
  var hasDobError = eligibility === null || eligibility === void 0 ? void 0 : eligibility.x12_rejection_reasons.some(function (reason) {
    return reason.code === '71';
  });
  var isExpired = (eligibility === null || eligibility === void 0 ? void 0 : eligibility.member_id_match) && (eligibility === null || eligibility === void 0 ? void 0 : eligibility.medicaid_member) === false && (eligibility === null || eligibility === void 0 ? void 0 : eligibility.managed_care_member) === false;
  var isNotVerified = (eligibility === null || eligibility === void 0 ? void 0 : eligibility.status) === 'not_verified';
  var isSkippedVerifyMissingNPI = (eligibility === null || eligibility === void 0 ? void 0 : eligibility.status) === 'skipped_verify_missing_npi';
  var eligibilityVerifiedAtDate = eligibility === null || eligibility === void 0 ? void 0 : eligibility.verified_at;
  var showEligibilityVerifiedDate = pays5525ShowCurrentInsuranceCoverage && !!eligibilityVerifiedAtDate;
  var renderMessage = function renderMessage() {
    if (isNotVerified) return /*#__PURE__*/React.createElement(SomethingWentWrong, null);
    if (isSkippedVerifyMissingNPI) return /*#__PURE__*/React.createElement(MissingNpiErrorMessage, null);
    return /*#__PURE__*/React.createElement(MatchMessage, {
      eligibility: eligibility,
      hasDobError: hasDobError,
      hasNameError: hasNameError,
      isPending: isPending,
      isExpired: isExpired
    });
  };
  return !!eligibility && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "mt-4 mb-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-base font-semibold"
  }, "NCTracks Verification")), renderMessage(), showEligibilityVerifiedDate && /*#__PURE__*/React.createElement(CurrentInsuranceCoverageMessage, {
    eligibilityVerifiedAtDate: eligibilityVerifiedAtDate
  }));
};
NcTracksVerification.propTypes = {
  insurance: PropTypes.shape({
    eligibilities: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired
    }))
  }).isRequired
};
//# sourceMappingURL=NcTracksVerification.js.map